const NoTableData = () => {
  return (
    <tr className='text-center'>
      <td colSpan={100}> No data found </td>
    </tr>
  );
};

export default NoTableData;
